import {
  type AccountDraft,
  emptyDraft,
  type SaveStatus,
  type ValidationErrors,
} from '../domain/account-draft.model';
import type { AccountSettingsError } from '../domain/account-settings-error';

/**
 * Redux state for the Account-settings form. The editable draft plus the save
 * lifecycle: there is no load status because the identity is hydrated from
 * `AuthContext` (the app-wide source of truth), not fetched here. Every field is
 * serialisable.
 */
/**
 * Lifecycle of a profile photo change (#579), independent of the form's save:
 * the photo is sent as soon as it is picked, with no Save button.
 */
export type AvatarStatus = 'idle' | 'uploading' | 'removing' | 'uploaded' | 'removed' | 'failed';

export interface AccountSettingsState {
  draft: AccountDraft;
  saveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: AccountSettingsError | null;
  avatarStatus: AvatarStatus;
  /** Why the last photo change failed; null otherwise. */
  avatarError: string | null;
}

export const initialState: AccountSettingsState = {
  draft: emptyDraft,
  saveStatus: 'idle',
  validationErrors: {},
  error: null,
  avatarStatus: 'idle',
  avatarError: null,
};
